import { createClient } from '@supabase/supabase-js'

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    '⚠️  Missing Supabase environment variables!\n' +
    'Please create a .env file with:\n' +
    'VITE_SUPABASE_URL=your-project-url\n' +
    'VITE_SUPABASE_ANON_KEY=your-anon-key'
  )
}

// Create Supabase client
export const supabase = createClient(
  supabaseUrl || 'http://localhost:54321',
  supabaseAnonKey || 'demo-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: window.localStorage, // Use localStorage so sessions persist across tabs/refreshes
      storageKey: 'sb-auth-token',
      flowType: 'pkce',
    },
  }
)

// Helper function to get current organization ID
// Note: This is now handled by organizationContext.ts
// This remains for backward compatibility
export const getCurrentOrgId = () => {
  // For backward compatibility with existing code
  // New code should use getCurrentOrgId() from organizationContext.ts
  return import.meta.env.VITE_ORGANIZATION_ID
}

// Helper to check if Supabase is configured
export const isSupabaseConfigured = () => {
  return !!(supabaseUrl && supabaseAnonKey && supabaseUrl !== 'http://localhost:54321')
}